import component from '@123/druid/dist/Framework/Decorators/Component';
import View from '@123/druid/dist/Framework/View/View';
import AlternativeButtonView from '@Component/Recommendation/Button/AlternativeButtonView';
import EventHub from '@Service/LegacyBridge/EventHub/EventHub';

@component
export default class SidePanelView extends View {
    protected mounted(): void {
        this.addEventHubListeners();
    }

    private addEventHubListeners(): void {
        EventHub.instance.on('SidePanel.Open', () => {
            this.getViews(AlternativeButtonView);
        });
    }
}
